var map = {
	"./award-1.svg": "DcXP",
	"./award-2.svg": "KUsc",
	"./award-3.svg": "yD0q",
	"./award-4.svg": "B/uA",
	"./award-5.svg": "8KA6",
	"./bigwiner.svg": "4XUM",
	"./botton-1.svg": "CV9O",
	"./botton-2.svg": "tCs1",
	"./botton-3.svg": "ar6I",
	"./botton-4.svg": "20D8",
	"./botton-5.svg": "Fwij",
	"./broadcast.svg": "m1Dl",
	"./car.svg": "MNJS",
	"./code.svg": "xuZk",
	"./dayang.svg": "lzFn",
	"./fangka.svg": "ZlyN",
	"./go-back-icon.svg": "g04D",
	"./isnewimg.svg": "pVNP",
	"./left-jt.svg": "tdyv",
	"./loginout.svg": "m9RW",
	"./management-1.svg": "wu3i",
	"./management-2.svg": "T476",
	"./management-3.svg": "QyzF",
	"./mark.svg": "Rvdz",
	"./memu.svg": "2Ynm",
	"./more.svg": "w7Cr",
	"./operating-1.svg": "UU+S",
	"./operating-2.svg": "dAWM",
	"./operating-3.svg": "Rdia",
	"./operating-4.svg": "/pRd",
	"./operating-5.svg": "VsfW",
	"./operating-6.svg": "YAZ6",
	"./operating-7.svg": "S507",
	"./passworld.svg": "mxIQ",
	"./phone.svg": "j445",
	"./qiehuan.svg": "CofW",
	"./qun.svg": "zWZQ",
	"./qunfk.svg": "faPN",
	"./right-jt.svg": "BB54",
	"./shuxian.svg": "/UzB",
	"./team-1.svg": "atfl",
	"./team-2.svg": "Hf9K",
	"./team-3.svg": "PxCW",
	"./team-4.svg": "4iZX",
	"./team-5.svg": "uVEM",
	"./user.svg": "kV7K",
	"./userName.svg": "iM3l",
	"./weixin.svg": "14Q+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "i+SB";


//////////////////
// WEBPACK FOOTER
// ./src/icons \.svg$
// module id = i+SB
// module chunks = 38